import { useField } from "formik";
import { forwardRef } from "react";
import { FieldError } from "@/components/uielements/forms/field-error";
import {
  Input as NativeInput,
  type Props as NativeInputProps,
} from "@/components/uielements/forms/input";

interface Props extends NativeInputProps {
  /** Formik inputs must include a `name` to identify the field. */
  name: string;
}

// eslint-disable-next-line react/display-name
export const Input = forwardRef<HTMLInputElement, Props>((props, ref) => {
  // @ts-expect-error: props doesn't match what formik expects
  const [field, { error, touched }] = useField(props);
  return (
    <>
      <NativeInput ref={ref} {...field} {...props} />
      {touched && error && <FieldError>{error}</FieldError>}
    </>
  );
});
